import React from 'react';
import s from './marker-labelled.module.css';

// A map pin that always shows its name. Used where the map is a diagram of a few
// fixed points — the auto-assign simulator — rather than a live view of a city.
//
// Deliberately a separate component from Marker/MarkerAddress/MarkerShop: those
// three are click-to-open, sized for one label at a time, and are what the Live
// and Shops maps use. Reusing them here would have meant changing behaviour for
// every driver pin in the product to fix a page that draws ten static ones.
//
// Nothing here takes pointer events: with no click behaviour left, a label that
// swallowed a drag would just make the map harder to pan.
const MarkerLabelled = React.memo(({ name, type }) => (
	<div
		style={{ position: 'absolute', transform: 'translate(-50%, -50%)', pointerEvents: 'none' }}
	>
		<div className={`${s.dot} ${s[type] || s.order}`} />
		{!!name && <div className={s.label}>{name}</div>}
	</div>
));

export default MarkerLabelled;
